import React from 'react';
import ThanksgivingVideos from '../components/ThanksgivingVideos';

const ThanksgivingPage = () => {
  return <ThanksgivingVideos />;
};

export default ThanksgivingPage;